import { AzureDevOpsConfig } from "../../Shared/AzureDevopsConfig";
import { PipelineRun } from "../../Types";

export function getConfigFileName(fileData: Record<string, any> | undefined) {
  if (!fileData) return "";
  return fileData.__filename?.replace(".json", "") || "";
}

export function formatDate(dateString: string | null | undefined) {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleString();
}

export function parseRolloutType(rolloutType: string) {
  if (!rolloutType) return { environment: "N/A", mode: "N/A" };
  const parts = rolloutType.split("_");
  if (parts.length >= 2) {
    const environment = parts[0];
    const modeType = parts[1];
    let modeProgression = "";
    if (modeType === "SDP") {
      modeProgression = parts.length > 2 ? ` ${parts[2]}` : " Automatic";
    }

    const mode = `${modeType}${modeProgression}`;
    return { environment, mode };
  }
  return { environment: rolloutType, mode: "N/A" };
}

export function getPipelineRunUrl(run: PipelineRun | string) {
  if (typeof run === "string") {
    return `https://dev.azure.com/${AzureDevOpsConfig.organization}/${AzureDevOpsConfig.project}/_build/results?buildId=${run}`;
  }
  return `https://dev.azure.com/${AzureDevOpsConfig.organization}/${AzureDevOpsConfig.project}/_build/results?buildId=${run.id}`;
}

/**
 * Cleans rollout params before submitting to the API.
 * - Removes '_Automatic' from RolloutAndProgressionType if present.
 * Add more cleanup rules as needed.
 */
export function cleanRolloutParams(
  params: Record<string, any>,
): Record<string, any> {
  const cleaned = { ...params };
  if (typeof cleaned["RolloutAndProgressionType"] === "string") {
    cleaned["RolloutAndProgressionType"] = cleaned[
      "RolloutAndProgressionType"
    ].replace(/_Automatic$/, "");
  }
  // Add more cleanup rules here if needed
  return cleaned;
}
